module.exports = __webpack_public_path__ + "media/images/official/special_hopper_terashima_profile-cc831894c5e91dfff997dd44df17f9b9.png";